<div class="mainform">

<button id="load-button"
        style="margin: 100px;"
        (click)="loadCourses()">Charger les profs</button>

  <app-tuto [step]="0"
            ids="load-button|prof-table"
            texts="Charger les professeurs depuis OASIS|Affichage du résultat du chargement">
  </app-tuto>

<table id="prof-table">
  <thead>
    <tr>
      <th>Code</th>
      <th>Nom</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let p of profs">
      <td>{{ p.nip }}</td>
      <td>{{ p.nom_usuel }}</td>
    </tr>
  </tbody>
</table>
</div>
